export default {
	overContactLimitError: 443,
};
